"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@phishtool/ui/src/assets");
